/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect} from "react"
import {useTranslation} from "react-i18next"
import cx from "classnames"
import moment from "moment"
import {useHistory} from "react-router-dom"
import {KlassappTable, KlassappTableHeader} from "uiKit"
import {KlassappTableHOC} from "HOC"
import styles from "./FinAidOffer.module.css"
import {finAidService} from "services"
import {useModel} from "hooks"
import {routing} from "helpers/routing"
import {getFullName} from "helpers"
import {KlassappTableProps} from "types/common"
import {Icon} from "components"
import {FinAidOffer} from "types/fin-aid/fin-aid"

interface Props extends KlassappTableProps {
    studentId: number
    awardYear: number
}

function FinAidOffers(props: Props) {
    const {
        dispatch,
        dispatchFunc,
        page,
        total,
        pageSize,
        columns,
        data,
        allFields,
        fields,
        tableHeaderActions,
        isLoading,
        menuActions,
        isHideMenuActions,
        isShowTableHeaderAction,
        getCurrentPage,
        getCurrentPageSize,
        studentId,
        awardYear
    } = props
    const history = useHistory()
    const model = useModel()
    const userDateTimeFormat = model.getUserDateTimeFormat()
    const {t} = useTranslation(["financialAid", "common"])

    const getPageTitle = () => {
        return t("finAidOffer.tableTitle")
    }

    const getFields = () => {
        return [
            t("finAidOffer.column.code"),
            t("finAidOffer.column.isir"),
            t("finAidOffer.column.studentProfile"),
            t("finAidOffer.column.awardYear"),
            t("finAidOffer.column.lastUpdated"),
            t("finAidOffer.column.status"),
            "actions"
        ]
    }

    const getColumns = () => {
        return [
            {
                title: t("finAidOffer.column.code"),
                field: "code",
                style: {minWidth: "100px"}
            },
            {
                title: t("finAidOffer.column.isir"),
                field: "finAidPackage.isir",
                style: {minWidth: "100px"}
            },
            {
                title: t("finAidOffer.column.studentProfile"),
                field: "studentProfile",
                style: {minWidth: "100px"},
                render: (value) => getFullName(value)
            },
            {
                title: t("finAidOffer.column.awardYear"),
                field: "awardYear",
                style: {minWidth: "60px"},
                render: (value) => `${value} - ${value + 1}`
            },
            {
                title: t("finAidOffer.column.isirSSN"),
                field: "finAidPackage.ssn",
                style: {minWidth: "50px"}
            },
            {
                title: t("finAidOffer.column.cps"),
                field: "cpsNo",
                style: {minWidth: "50px"}
            },
            {
                title: t("finAidOffer.column.primaryEFC"),
                field: "finAidPackage.efc",
                style: {minWidth: "80px"}
            },
            {
                title: t("finAidOffer.column.createdBy"),
                field: "createdAt",
                style: {minWidth: "150px"},
                render: (value, record) => (
                    <div className={styles.statusInfo}>
                        <div className={styles.statusInfo__text}>{getFullName(record.createdBy)}</div>
                        <div className={styles.statusInfo__text}>{moment(value).format(userDateTimeFormat)}</div>
                    </div>
                )
            },
            {
                title: t("finAidOffer.column.lastUpdated"),
                field: "updatedAt",
                style: {minWidth: "150px"},
                render: (value, record) => (
                    <div className={styles.statusInfo}>
                        <div className={styles.statusInfo__text}>{getFullName(record.updatedBy)}</div>
                        <div className={styles.statusInfo__text}>{moment(value).format(userDateTimeFormat)}</div>
                    </div>
                )
            },
            {
                title: t("finAidOffer.column.status"),
                field: "status",
                style: {minWidth: "90px"},
                render: (value) => <div className={cx(styles.status, value)}>{t(`finAidOffer.status.${value}`)}</div>
            },
            {
                title: "actions",
                render: (_, record: FinAidOffer) => (
                    <div className="flex flex-row items-center justify-center gap-4">
                        <div
                            onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                history.push(
                                    routing.finAid.student.offerDetail(record.studentProfileId, record.finAidOfferId)
                                )
                            }}>
                            <Icon icon="EDIT_LINE" />
                        </div>
                        <div
                            onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                history.push(
                                    routing.finAid.student.offerDetail2(record.studentProfileId, record.finAidPackageId)
                                )
                            }}>
                            <Icon icon="EDIT_LINE" />
                        </div>
                    </div>
                )
            }
        ]
    }

    const getData = async () => {
        dispatch({isLoading: true})
        const page = getCurrentPage()
        const pageSize = getCurrentPageSize()
        const {total, data} = await finAidService.getFinAidOffers({
            filter: {studentProfileId: [studentId], awardYear},
            range: {
                page,
                pageSize
            },
            linkedObjects: true,
            linkedPackage: true
        })
        dispatch({total, data: data.map((item) => ({...item, id: item.finAidOfferId})), isLoading: false})
    }

    const getTableHeaderActions = React.useCallback(
        (isShowDuplicateBtn = true, checkedData = []) => {
            if (checkedData.length > 1) {
                return []
            }
            return []
        },
        [t]
    )

    const getMenuActions = React.useCallback(() => {
        return [
            // {
            //     title: t("common:action.edit"),
            //     icon: "EDIT",
            //     action: onClickEdit
            // }
            // {
            //     title: t("common:action.delete"),
            //     icon: "DELETE",
            //     action: () => onClickShowConfirmModal("DELETE"),
            // }
        ]
    }, [])

    const onClickRowItem = ({studentProfileId, finAidOfferId}) => {
        // history.push(routing.finAid.student.offerDetail(studentProfileId, finAidOfferId))
    }

    const onClickDeleteMulti = () => {}

    const onClickDuplicateMulti = () => {}

    const onClickEdit = ({studentProfileId, finAidOfferId}) => {
        history.push(routing.finAid.student.offerDetail(studentProfileId, finAidOfferId))
    }

    const onClickDelete = async ({finAidOfferId}) => {
        await finAidService.deleteFinAidOffer(finAidOfferId)
        await getData()
    }

    useEffect(() => {
        dispatch({isClassComponent: false})
        dispatchFunc([
            {key: "getPageTitle", func: getPageTitle},
            {key: "getListData", func: getData},
            {key: "getFields", func: getFields},
            {key: "getColumns", func: getColumns},
            {key: "getTableHeaderActions", func: getTableHeaderActions},
            {key: "getMenuActions", func: getMenuActions},
            {key: "onClickDeleteMulti", func: onClickDeleteMulti},
            {key: "onClickDuplicateMulti", func: onClickDuplicateMulti},
            {key: "onClickEdit", func: onClickEdit},
            {key: "onClickDelete", func: onClickDelete},
            {key: "onClickRowItem", func: onClickRowItem}
        ])
    }, [])

    useEffect(() => {
        getData()
    }, [])

    useEffect(() => {
        getData()
    }, [page, pageSize])

    const [, setSearch] = React.useState("")
    const [filter, setFilter] = React.useState<Record<string, any>>({})

    const onApplyFilter = () => {}

    const onClearFilter = () => {
        setFilter({})
    }

    const onSearchInput = (search) => {
        setSearch(search)
    }

    return (
        <div>
            {/*
            <BaseNewFilter
                filter={filter}
                onClick={onApplyFilter}
                onClickClear={onClearFilter}
                onSearchInput={onSearchInput}>
                <Row gutter={[24, 24]}>
                    <Col span={12}></Col>
                    <Col span={12}></Col>
                </Row>
            </BaseNewFilter>
*/}
            <KlassappTableHeader
                isShowAction={isShowTableHeaderAction}
                actions={tableHeaderActions}
                page={page}
                total={total}
                defaultPageSize={pageSize}
                onChangePage={props.onChangePage}
                onChangeRowPerPage={props.onChangeRowPerPage}
                fields={fields}
                allFields={allFields}
                onChangeFields={props.onChangeFields}
                onChangeAllFields={props.onChangeAllFields}
                onDraggableColumn={props.onDraggableColumn}
            />
            <KlassappTable
                columns={columns}
                data={data}
                isLoading={isLoading}
                menuActions={isHideMenuActions ? [] : menuActions}
                fields={fields}
                allFields={allFields}
                isShowCheckedColumn
                onClickRowItem={onClickRowItem}
                onChangeFields={props.onChangeFields}
                onUpdateRowData={props.onUpdateRowData}
                onUpdateTableData={props.onUpdateTableData}
            />
        </div>
    )
}

export default KlassappTableHOC(FinAidOffers)
